import { Checkbox } from "@mui/material";
import { convertLocaltoUTCFormat } from "../services/DateFormatUtility";
import { ClaimType } from "./claims";
import { size } from "lodash";

export const BdnSummaryHeaders = [
	{
		header: "Date of Operation",
		accessorKey: "dateOfOperation",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateOfOperation) {
				return convertLocaltoUTCFormat(row.dateOfOperation);
			}
		},
	},
	{
		header: "HFO",
		accessorKey: "hfoBdn",
	},
	{
		header: "LFO",
		accessorKey: "lfoBdn",
	},
	{
		header: "DO/GO",
		accessorKey: "mD_DO",
		accessorFn: (row) => {
			if (row) {
				return row.mD_DO;
			}
		},
	},
	{
		header: "LPG (P)",
		accessorKey: "lpgpBdn",
	},
	{
		header: "LPG (B)",
		accessorKey: "lpgbBdn",
	},
	{
		header: "LNG",
		accessorKey: "lngBdn",
	},
	{
		header: "Methanol",
		accessorKey: "methanolBdn",
	},
	{
		header: "Ethanol",
		accessorKey: "ethanolBdn",
	},
	{
		header: "Other Fuel 1",
		accessorKey: "otherFuel1Bdn",
	},
	{
		header: "Other Fuel 2",
		accessorKey: "otherFuel2Bdn",
	},
	{
		header: "Other Fuel 3",
		accessorKey: "otherFuel3Bdn",
	},
	{
		header: "Remarks",
		accessorKey: "description",
	},
];

export const EUMRV_PORTSTAYS_HEADERS = {
	EMISSION_REPORT: "Emissions Reported",
	CCS_CCU: "Part C.1.4 - Derogation from CCS & CCU",
	OMR: "Part C.1.5 – Derogation from OMR, PSC/O, and Small Islands",
	ICE_CLASS: "Part C.1.6 – Derogation from Ice Class",
	PHASE_IN:
		"Part C.1.7 – Derogation from Phase-In (40% for RY 2024, 70% for RY 2025, 100% from RY 2026 onwards)",
	EMISSION_DEROGATION: "Emissions After Derogations",
};

export const EuMrvPortStaysColumnsOld = [
	{
		id: "childMrvPortStayDtlId",
		accessorKey: "",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "PortName",
		accessorKey: "portName",
		header: "Port",
	},
	{
		id: "DateTimeArrival",
		accessorKey: "dateTimeArrival",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateTimeArrival) {
				return convertLocaltoUTCFormat(row.dateTimeArrival);
			}
		},
	},
	{
		id: "DateTimeDeparture",
		accessorKey: "dateTimeDeparture",
		header: "Date and Time of Depature (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateTimeDeparture) {
				return convertLocaltoUTCFormat(row.dateTimeDeparture);
			}
		},
	},
	{
		id: "TimeInPort",
		accessorKey: "timeInPort",
		header: "Time in Port (h)",
	},
	{
		id: "HfoCons",
		accessorKey: "hfoCons",
		header: "HFO Cons. (MT)",
	},
	{
		id: "LfoCons",
		accessorKey: "lfoCons",
		header: "LFO Cons. (MT)",
	},
	{
		id: "DieselGasOilCons",
		accessorKey: "dieselGasOilCons",
		header: "Diesel/Gas Oil Cons. (MT)",
	},
	{
		id: "MdoCons",
		accessorKey: "mdoCons",
		header: "MDO Cons. (MT)",
	},
	{
		id: "MgoCons",
		accessorKey: "mgoCons",
		header: "MGO Cons. (MT)",
	},
	{
		id: "LpgbCons",
		accessorKey: "lpgbCons",
		header: "LPG (butane) Cons. (MT)",
	},
	{
		id: "LpgpCons",
		accessorKey: "lpgpCons",
		header: "LPG (propane) Cons. (MT)",
	},
	{
		id: "LngCons",
		accessorKey: "lngCons",
		header: "LNG Cons. (MT)",
	},
	{
		id: "LngMnc",
		accessorKey: "lngMnc",
		header: "LNG MNC. ",
	},
	{
		id: "MethanolCons",
		accessorKey: "methanolCons",
		header: "Methanol Cons. (MT)",
	},
	{
		id: "EthanolCons",
		accessorKey: "ethanolCons",
		header: "Ethanol Cons. (MT)",
	},
	{
		id: "OtherFuel1Cons",
		accessorKey: "otherFuel1Cons",
		header: "Other Fuel 1 Cons. (MT)",
	},
	{
		id: "OtherFuel1Mnc",
		accessorKey: "otherFuel1Mnc",
		header: "Other Fuel 1 MNC",
	},
	{
		id: "OtherFuel2Cons",
		accessorKey: "otherFuel2Cons",
		header: "Other Fuel 2 Cons. (MT)",
	},
	{
		id: "OtherFuel2Mnc",
		accessorKey: "otherFuel2Mnc",
		header: "Other Fuel 2 MNC",
	},
	{
		id: "OtherFuel3Cons",
		accessorKey: "otherFuel3Cons",
		header: "Other Fuel 3 Cons. (MT)",
	},
	{
		id: "OtherFuel3Mnc",
		accessorKey: "otherFuel3Mnc",
		header: "Other Fuel 3 MNC",
	},
	{
		id: "DirectCo2Measurement",
		accessorKey: "directCo2Measurement",
		header: "Direct CO2 Measure(MT)",
	},
	{
		id: "AmountOfCarbonCaptureAndStorage",
		header: "Amount of carbon capture & storage (MT)",
		accessorKey: "amountOfCarbonCaptureAndStorage",
	},
	{
		id: "Description",
		accessorKey: "description",
		header: "Description",
	},
];

export const EuMrvPortStaysColumns = [
	{
		id: "psEm_portCodeMstId",
		accessorKey: "portCodeMstId",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "psEm_portName",
		accessorKey: "portName",
		header: "Port",
	},
	{
		id: "psEm_arrivalTime",
		accessorKey: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "psEm_departureTime",
		accessorKey: "departureTime",
		header: "Date and Time of Departure (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "psEm_timeInPort",
		accessorKey: "timeInPort",
		header: "Time in Port (h)",
	},
	{
		id: "psEm_timeAtSea",
		accessorKey: "timeAtSea",
		header: "Time at Sea (h)",
	},
	{
		id: "psEm_distanceTravelled",
		accessorKey: "distanceTravelled",
		header: "Distance Travelled (nm)",
	},
	{
		id: "psEm_amountOfCarbonCapture",
		accessorKey: "amountOfCarbonCapture",
		header: "Amount of carbon capture & storage (MT)",
	},
	{
		id: "psEm_co2Mrv",
		accessorKey: "co2Mrv",
		header: "CO2 MRV (MT)",
	},
	{
		id: "psEm_ch4Mrv",
		accessorKey: "ch4Mrv",
		header: "CH4 MRV (MT)",
	},
	{
		id: "psEm_n2oMrv",
		accessorKey: "n2oMrv",
		header: "N2O MRV (MT)",
	},
	{
		id: "psEm_co2EqMrv",
		accessorKey: "co2EqMrv",
		header: "CO2eq MRV (MT)",
	},
	{
		id: "psEm_co2Ets",
		accessorKey: "co2Ets",
		header: "CO2 ETS (MT)",
	},
	{
		id: "psEm_ch4Ets",
		accessorKey: "ch4Ets",
		header: "CH4 ETS (MT)",
	},
	{
		id: "psEm_n2oEts",
		accessorKey: "n2oEts",
		header: "N2O ETS (MT)",
	},
	{
		id: "psEm_co2EqEts",
		accessorKey: "co2EqEts",
		header: "CO2eq ETS (MT)",
	},
	{
		id: "psEm_description",
		accessorKey: "description",
		header: "Description",
	},
];

export const DerogationCCSandCCUColumns = [
	{
		id: "ps_ccs_psNo",
		accessorKey: "",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "ps_ccs_portName",
		accessorKey: "portName",
		header: "Port",
	},
	{
		id: "ps_ccs_arrivalTime",
		accessorKey: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "ps_ccs_departureTime",
		accessorKey: "departureTime",
		header: "Date and Time of Departure (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "ps_ccs_carbonCapture",
		accessorKey: "carbonCapture",
		header: "Amount of carbon capture & storage (MT)",
	},
	{
		id: "ps_ccs_co2EqMrv",
		accessorKey: "co2EqMrv",
		header: "CO2eq (MT)",
	},
		{
		id: "ps_ccs_co2EqEts",
		accessorKey: "co2EqEts",
		header: "CO2eq ETS (MT)",
	},
];

export const DerogationOMRColumns = [
	{
		accessorKey: "ChildMrvPortStayDtlId",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		accessorKey: "portName",
		header: "Port",
	},
	{
		accessorKey: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		accessorKey: "departureTime",
		header: "Date and Time of Departure (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		header: "Is Small Island Applicable?",
		accessorKey: "isSi",
		Cell: ({ row }) => {
			const isSmallIsland = row?.original?.isSi;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isSmallIsland}
						checked={isSmallIsland}
					/>
				</div>
			);
		},
	},
	{
		header: "Is Transnational Applicable?",
		accessorKey: "isTnl",
		Cell: ({ row }) => {
			const isTransnational = row?.original?.isTnl;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isTransnational}
						checked={isTransnational}
					/>
				</div>
			);
		},
	},
	{
		header: "Is OMR Applicable?",
		accessorKey: "isOmr",
		Cell: ({ row }) => {
			const isOMR = row?.original?.isOmr;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isOMR}
						checked={isOMR}
					/>
				</div>
			);
		},
	},
	{
		header: "Reduction factor (RF)",
		accessorKey: "reductionFactor",
	},
	{
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	}
];

export const DerogationIceClassColumns = [
	{
		accessorKey: "ChildMrvPortStayDtlId",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		accessorKey: "portName",
		header: "Port",
	},
	{
		accessorKey: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		accessorKey: "departureTime",
		header: "Date and Time of Departure (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		header: "Ice Class",
		accessorKey: "iceClass",
	},
	{
		header: "RF",
		accessorKey: "reductionFactor",
	},
	{
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	},
];

export const DerogationPhaseInColumns = [
	{
		accessorKey: "ChildMrvPortStayDtlId",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		accessorKey: "portName",
		header: "Port",
	},
	{
		accessorKey: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		accessorKey: "departureTime",
		header: "Date and Time of Departure (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		header: "Reporting Year",
		accessorKey: "reportingYear",
	},
	{
		header: "Reduction factor (RF)",
		accessorKey: "reductionFactor",
	},
	{
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	}
];

export const EmissionsAfterDerogationColumns = [
	{
		id: "ps_ChildMrvPortStayDtlId",
		accessorKey: "ChildMrvPortStayDtlId",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "ps_portName",
		accessorKey: "portName",
		header: "Port",
	},
	{
		id: "ps_arrivalTime",
		accessorKey: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "ps_departureTime",
		accessorKey: "departureTime",
		header: "Date and Time of Departure (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "ps_timeInPort",
		accessorKey: "timeInPort",
		header: "Time in Port (h)",
	},
	{
		id: "ps_timeAtSea",
		accessorKey: "timeAtSea",
		header: "Time at Sea (h)",
	},
	{
		id: "ps_distanceTravelled",
		accessorKey: "distanceTravelled",
		header: "Distance Travelled (nm)",
	},
	{
		id: "ps_amountOfCarbonCapture",
		accessorKey: "amountOfCarbonCapture",
		header: "Amount of carbon capture & storage (MT)",
	},
	{
		id: "ps_co2Mrv",
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		id: "ps_ch4Mrv",
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		id: "ps_n2oMrv",
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		id: "ps_co2EqMrv",
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		id: "ps_co2Ets",
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		id: "ps_ch4Ets",
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		id: "ps_n2oEts",
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		id: "ps_co2EqEts",
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	},
	{
		id: "ps_description",
		header: "Description",
		accessorKey: "description",
	},
];

export const BdnSummaryRemainingOilColumns = [
	{
		header: "Date of Operation",
		accessorKey: "timeStamp",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.timeStamp) {
				return convertLocaltoUTCFormat(row.timeStamp);
			}
		},
	},
	{
		header: "HFO",
		accessorKey: "hfoRob",
	},
	{
		header: "LFO",
		accessorKey: "lfoRob",
	},
	{
		header: "DO/GO",
		accessorKey: "dogo",
		accessorFn: (row) => {
			if (row) {
				return row.dogo;
			}
		},
	},
	{
		header: "LPG (P)",
		accessorKey: "lpgpRob",
	},
	{
		header: "LPG (B)",
		accessorKey: "lpgbRob",
	},
	{
		header: "LNG",
		accessorKey: "lngRob",
	},
	{
		header: "Methanol",
		accessorKey: "methanolRob",
	},
	{
		header: "Ethanol",
		accessorKey: "ethanolRob",
	},
	{
		header: "Other Fuel 1",
		accessorKey: "otherFuel1Rob",
	},
	{
		header: "Other Fuel 2",
		accessorKey: "otherFuel2Rob",
	},
	{
		header: "Other Fuel 3",
		accessorKey: "otherFuel3Rob",
	},
	{
		header: "Remarks",
		accessorKey: "description",
	},
];

export const BdnOtherCorrectionColumns = [
	{
		header: "Date of Operation",
		accessorKey: "dateOfOperation",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateOfOperation) {
				return convertLocaltoUTCFormat(row.dateOfOperation);
			}
		},
	},
	{
		header: "HFO",
		accessorKey: "hfoBdn",
	},
	{
		header: "LFO",
		accessorKey: "lfoBdn",
	},
	{
		header: "DO/GO",
		accessorKey: "mD_DO",
		accessorFn: (row) => {
			if (row) {
				return row.mD_DO;
			}
		},
	},
	{
		header: "LPG(P)",
		accessorKey: "lpgpBdn",
	},
	{
		header: "LPG(B)",
		accessorKey: "lpgbBdn",
	},
	{
		header: "LNG",
		accessorKey: "lngBdn",
	},
	{
		header: "Methanol",
		accessorKey: "methanolBdn",
	},
	{
		header: "Ethanol",
		accessorKey: "ethanolBdn",
	},
	{
		header: "Other Fuel 1",
		accessorKey: "otherFuel1Bdn",
	},
	{
		header: "Other Fuel 2",
		accessorKey: "otherFuel2Bdn",
	},
	{
		header: "Other Fuel 3",
		accessorKey: "otherFuel3Bdn",
	},
	{
		header: "Remarks",
		accessorKey: "description",
	},
];

export const BdnAnnualFuelConsumptionColumns = [
	// {
	// 	header: "Date of Operation",
	// 	accessorKey: "dateOfOperation",
	// 	muiEditTextFieldProps: {
	// 		type: "datetime-local",
	// 	},
	// 	accessorFn: (row) => {
	// 		if (row.dateOfOperation) {
	// 			return moment(row.dateOfOperation).format("DD-MMM-YYYY");
	// 		}
	// 	},
	// },
	{
		header: " ",
		accessorFn: (row) => (
			<span style={{ fontSize: "0.97em" }}>Annual Fuel Consumption</span>
		),
	},
	{
		header: "HFO",
		accessorKey: "hfoBdn",
	},
	{
		header: "LFO",
		accessorKey: "lfoBdn",
	},
	{
		header: "DO/GO",
		accessorKey: "mD_DO",
		accessorFn: (row) => {
			if (row) {
				return row.mD_DO;
			}
		},
	},
	{
		header: "LPG (P)",
		accessorKey: "lpgpBdn",
	},
	{
		header: "LPG (B)",
		accessorKey: "lpgbBdn",
	},
	{
		header: "LNG",
		accessorKey: "lngBdn",
	},
	{
		header: "Methanol",
		accessorKey: "methanolBdn",
	},
	{
		header: "Ethanol",
		accessorKey: "ethanolBdn",
	},
	{
		header: "Other Fuel 1",
		accessorKey: "otherFuel1Bdn",
	},
	{
		header: "Other Fuel 2",
		accessorKey: "otherFuel2Bdn",
	},
	{
		header: "Other Fuel 3",
		accessorKey: "otherFuel3Bdn",
	},
	{
		header: "Remarks",
		accessorKey: "description",
	},
];

export const UkMrvPortStaysColumns = [
	{
		id: "portNumber",
		accessorKey: "",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "portName",
		accessorKey: "portName",
		header: "Port",
	},
	{
		id: "arrivalTime",
		accessorKey: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "departureTime",
		accessorKey: "departureTime",
		header: "Date and Time of Depature (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "timeInPort",
		accessorKey: "timeInPort",
		header: "Time in Port (h)",
	},
	{
		id: "amountOfCarbonCapture",
		header: "Amount of carbon capture & storage (MT)",
		accessorKey: "amountOfCarbonCapture",
	},
	{
		id: "description",
		accessorKey: "description",
		header: "Description",
	},
];

export const UkEtsPortStaysColumns = [
	{
		id: "portNumber",
		accessorKey: "",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "portName",
		accessorKey: "portName",
		header: "Port",
	},
	{
		id: "arrivalTime",
		accessorKey: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "departureTime",
		accessorKey: "departureTime",
		header: "Date and Time of Depature (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "timeInPort",
		accessorKey: "timeInPort",
		header: "Time in Port (h)",
	},
	{
		id: "timeInPortAtBerth",
		accessorKey: "timeInPortAtBerth",
		header: "Time in Port at Berth(h)",
	},
	{
		id: "timeInPortInMovement",
		accessorKey: "timeInPortInMovement",
		header: "Time In Port Movement(h)",
	},
	
];

export const UkMrvOldPortStaysColumns = [
	{
		id: "ChildMrvPortStayDtlId",
		accessorKey: "",
		header: "Port Number",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "portName",
		accessorKey: "portName",
		header: "Port",
	},
	{
		id: "dateTimeArrival",
		accessorKey: "dateTimeArrival",
		header: "Date and Time of Arrival (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateTimeArrival) {
				return convertLocaltoUTCFormat(row.dateTimeArrival);
			}
		},
	},
	{
		id: "dateTimeDeparture",
		accessorKey: "dateTimeDeparture",
		header: "Date and Time of Depature (UTC)",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateTimeDeparture) {
				return convertLocaltoUTCFormat(row.dateTimeDeparture);
			}
		},
	},
	{
		id: "timeInPort",
		accessorKey: "timeInPort",
		header: "Time in Port (h)",
	},
	{
		id: "hfoCons",
		accessorKey: "hfoCons",
		header: "HFO Cons. (MT)",
	},
	{
		id: "lfoCons",
		accessorKey: "lfoCons",
		header: "LFO Cons. (MT)",
	},
	{
		id: "dieselGasOilCons",
		accessorKey: "dieselGasOilCons",
		header: "Diesel/Gas Oil Cons. (MT)",
	},
	{
		id: "mdoCons",
		accessorKey: "mdoCons",
		header: "MDO Cons. (MT)",
	},
	{
		id: "mgoCons",
		accessorKey: "mgoCons",
		header: "MGO Cons. (MT)",
	},
	{
		id: "lpgbCons",
		accessorKey: "lpgbCons",
		header: "LPG (Butane) Cons. (MT)",
	},
	{
		id: "lpgpCons",
		accessorKey: "lpgpCons",
		header: "LPG (Propane) Cons. (MT)",
	},
	{
		id: "lngCons",
		accessorKey: "lngCons",
		header: "LNG Cons. (MT)",
	},
	{
		id: "lngMnc",
		accessorKey: "lngMnc",
		header: "LNG MNC. (MT)",
	},
	{
		id: "methanolCons",
		accessorKey: "methanolCons",
		header: "Methanol Cons. (MT)",
	},
	{
		id: "ethanolCons",
		accessorKey: "ethanolCons",
		header: "Ethanol Cons. (MT)",
	},
	{
		id: "otherFuel1Cons",
		accessorKey: "otherFuel1Cons",
		header: "Other Fuel 1 Cons. (MT)",
	},
	{
		id: "otherFuel1Mnc",
		accessorKey: "otherFuel1Mnc",
		header: "Other Fuel 1 MNC",
	},
	{
		id: "otherFuel2Cons",
		accessorKey: "otherFuel2Cons",
		header: "Other Fuel 2 Cons. (MT)",
	},
	{
		id: "otherFuel2Mnc",
		accessorKey: "otherFuel2Mnc",
		header: "Other Fuel 2 MNC",
	},
	{
		id: "otherFuel3Cons",
		accessorKey: "otherFuel3Cons",
		header: "Other Fuel 3 Cons. (MT)",
	},
	{
		id: "otherFuel3Mnc",
		accessorKey: "otherFuel3Mnc",
		header: "Other Fuel 3 MNC",
	},
	{
		id: "directCo2Measurement",
		accessorKey: "directCo2Measurement",
		header: "Direct CO2 Measure (MT)",
	},
	{
		id: "amountOfCarbonCaptureAndStorage",
		header: "Amount of carbon capture & storage (MT)",
		accessorKey: "amountOfCarbonCaptureAndStorage",
	},
	{
		id: "description",
		accessorKey: "description",
		header: "Description",
	},
];

export const EUMRV_VOYAGES_HEADERS = {
	EMISSION_REPORT: "Emissions Reported",
	CCS_CCU: "Part C.1.4 - Derogation from CCS & CCU",
	GEOGRAPHIC_SCOPE: "Part C.1.3 - Derogation from geographic scope",
	OMR: "Part C.1.5 - Derogation from OMR, PSC/O, and Small Islands",
	ICE_CLASS: "Part C.1.6 – Derogation from Ice Class",
	PHASE_IN:
		"Part C.1.7 - Derogation from Phase-In (40% for RY 2024, 70% for RY 2025, 100% from RY 2026 onwards)",
	EMISSION_DEROGATION: "Emissions After Derogations",
};

export const EUMRVVoyageOldColumnsData = [
	{
		id: "voyageNumber",
		header: "Voyage Number",
		accessorKey: "",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "isSampleVoyage",
		header: "Is Sample Voyage",
		accessorKey: "isSampleVoyage",
		Cell: ({ row }) => {
			const isSampleVoyage = row?.original?.isSampleVoyage;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isSampleVoyage}
						checked={isSampleVoyage}
					/>
				</div>
			);
		},
	},
	{
		id: "portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
		size: 250,
	},
	{
		id: "portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		id: "dateTimeDeparture",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "dateTimeDeparture",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateTimeDeparture) {
				return convertLocaltoUTCFormat(row.dateTimeDeparture);
			}
		},
	},
	{
		id: "dateTimeArrival",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "dateTimeArrival",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateTimeArrival) {
				return convertLocaltoUTCFormat(row.dateTimeArrival);
			}
		},
	},
	{
		id: "voyageDuration",
		header: "Voyage Duration (h)",
		accessorKey: "voyageDuration",
	},
	{
		id: "timeAtSea",
		header: "Time at Sea (h)",
		accessorKey: "timeAtSea",
	},
	{
		id: "calcTimeAtSea",
		header: "Calc Time at Sea (h)",
		accessorKey: "calcTimeAtSea",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "timeAtAnchor",
		header: "Time at Anchorage (h)",
		accessorKey: "timeAtAnchor",
	},
	{
		id: "distanceTravelled",
		header: "Distance Travelled (nm)",
		accessorKey: "distanceTravelled",
	},
	{
		id: "calcDistance",
		header: "Calc Distance (nm)",
		accessorKey: "calcDistance",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "cargoCarriedMt",
		header: "Cargo Carried (MT)",
		accessorKey: "cargoCarriedMt",
	},
	{
		id: "cargoCarriedM3",
		header: "Cargo Carried (M3)",
		accessorKey: "cargoCarriedM3",
	},
	{
		id: "cargoCarriedDwt",
		header: "Cargo Carried (DWT)",
		accessorKey: "cargoCarriedDwt",
	},
	{
		id: "cargoCarriedPax",
		header: "Cargo Carried (PAX)",
		accessorKey: "cargoCarriedPax",
	},
	{
		id: "hfoCons",
		header: "HFO Cons. (MT)",
		accessorKey: "hfoCons",
	},
	{
		id: "lfoCons",
		header: "LFO Cons. (MT)",
		accessorKey: "lfoCons",
	},
	{
		id: "dieselGasOilCons",
		header: "Diesel/Gas Oil Cons. (MT)",
		accessorKey: "dieselGasOilCons",
	},
	{
		id: "mdoCons",
		header: "MDO Cons. (MT)",
		accessorKey: "mdoCons",
	},
	{
		id: "mgoCons",
		header: "MGO Cons. (MT)",
		accessorKey: "mgoCons",
	},
	{
		id: "lpgpCons",
		header: "LPG (Propane) Cons. (MT)",
		accessorKey: "lpgpCons",
	},
	{
		id: "lpgbCons",
		header: "LPG (Butane) Cons. (MT)",
		accessorKey: "lpgbCons",
	},
	{
		id: "lngCons",
		header: "LNG Cons. (MT)",
		accessorKey: "lngCons",
	},
	{
		id: "lngMnc",
		header: "LNG MNC",
		accessorKey: "lngMnc",
	},
	{
		id: "methanolCons",
		header: "Methanol Cons. (MT)",
		accessorKey: "methanolCons",
	},
	{
		id: "ethanolCons",
		header: "Ethanol Cons. (MT)",
		accessorKey: "ethanolCons",
	},
	{
		id: "otherFuel1Cons",
		header: "Other Fuel 1 Cons. (MT)",
		accessorKey: "otherFuel1Cons",
	},
	{
		id: "otherFuel1Mnc",
		header: "Other Fuel 1 MNC. (MT)",
		accessorKey: "otherFuel1Mnc",
	},
	{
		id: "otherFuel2Cons",
		header: "Other Fuel 2 Cons. (MT)",
		accessorKey: "otherFuel2Cons",
	},
	{
		id: "otherFuel2Mnc",
		header: "Other Fuel 2 MNC. (MT)",
		accessorKey: "otherFuel2Mnc",
	},
	{
		id: "otherFuel3Cons",
		header: "Other Fuel 3 Cons. (MT)",
		accessorKey: "otherFuel3Cons",
	},
	{
		id: "otherFuel3Mnc",
		header: "Other Fuel 3 MNC. (MT)",
		accessorKey: "otherFuel3Mnc",
	},
	{
		id: "carbonCaptureStorage",
		header: "Amount of carbon capture & storage (MT)",
		accessorKey: "carbonCaptureStorage",
	},
	{
		id: "directCo2",
		header: "Direct CO2 Measurement (MT)",
		accessorKey: "directCo2",
	},
	{
		id: "description",
		header: "Description",
		accessorKey: "description",
	},
];

export const EUMRVVoyageColumnsData = [
	{
		header: "Voyage Number",
		id: "Voyage_VoyageNumber",
		accessorKey: "VoyageNumber",
		Cell: ({ row }) => row.index + 1,
	},

	{
		header: "Is Sample Voyage",
		id: "Voyage_isSampleVoyage",
		accessorKey: "isSampleVoyage",
		Cell: ({ row }) => {
			const isSampleVoyage = row?.original?.isSampleVoyage;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isSampleVoyage}
						checked={isSampleVoyage}
					/>
				</div>
			);
		},
	},

	{
		id: "Voyage_portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
	},
	{
		id: "Voyage_portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		id: "Voyage_departureTime",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "departureTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "Voyage_arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "arrivalTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "Voyage_voyageDuration",
		header: "Voyage Duration (h)",
		accessorKey: "voyageDuration",
	},
	{
		id: "Voyage_timeAtSea",
		header: "Time at Sea (h)",
		accessorKey: "timeAtSea",
	},
	{
		id: "Voyage_calcTimeAtSea",
		header: "Calc Time at Sea (h)",
		accessorKey: "calcTimeAtSea",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "Voyage_timeAtAnchor",
		header: "Time at Anchorage (h)",
		accessorKey: "timeAtAnchor",
	},
	{
		id: "Voyage_distanceTravelled",
		header: "Distance Travelled (nm)",
		accessorKey: "distanceTravelled",
	},
	{
		id: "Voyage_calcDistanceTravelled",
		header: "Calculated Distance (nm)",
		accessorKey: "calcDistanceTravelled",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},

	{
		id: "Voyage_sailingInIce",
		header: "Sailing in Ice (Y/N)",
		accessorKey: "sailingInIce",
		Cell: ({ row }) => {
			const sailingInIce = row?.original?.sailingInIce;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!sailingInIce}
						checked={sailingInIce}
					/>
				</div>
			);
		},
	},
	{
		id: "Time_at_sea_through_ice",
		header: "Time at Sea Ice (h)",
		accessorKey: "timeAtSeaThroughIce",
	},
	{
		id: "Distance_travelled_through_ice",
		header: "Distance Travel Ice(nm)",
		accessorKey: "distanceTravelledThroughIce",
	},

	{
		id: "Voyage_cargoMt",
		header: "Cargo Carried (MT)",
		accessorKey: "cargoMt",
	},
	{
		id: "Voyage_cargoM3",
		header: "Cargo Carried (M3)",
		accessorKey: "cargoM3",
	},
	{
		id: "Voyage_cargoDwt",
		header: "Cargo Carried (DWT)",
		accessorKey: "cargoDwt",
	},
	{
		id: "Voyage_cargoPax",
		header: "Cargo Carried (PAX)",
		accessorKey: "cargoPax",
	},
	{
		id: "Voyage_amountOfCarbonCapture",
		header: "Amount of carbon capture & storage (MT)",
		accessorKey: "amountOfCarbonCapture",
	},
	{
		id: "Voyage_co2Mrv",
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		id: "Voyage_ch4Mrv",
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		id: "Voyage_n2oMrv",
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		id: "Voyage_co2EqMrv",
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		id: "Voyage_co2Ets",
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		id: "Voyage_ch4Ets",
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		id: "Voyage_n2oEts",
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		id: "Voyage_co2EqEts",
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	},
	{
		id: "Voyage_description",
		header: "Description",
		accessorKey: "description",
	},
];

export const EUVoyagesDerogationGeographicScopeColumns = [
	{
		header: "Voyage Number",
		accessorKey: "VoyageNumber",
		Cell: ({ row }) => row.index + 1,
	},
	{
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
	},
	{
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		header: "Date and Time of Departure (UTC)",
		accessorKey: "departureTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "arrivalTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		header: "Reduction factor (RF)",
		accessorKey: "reductionFactor",
	},
	{
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	},
];

export const EUVoyagesDerogationCCSandCCUColumns = [
	{
		id: "voyage_ccs_VoyageNumber",
		header: "Voyage Number",
		accessorKey: "",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "voyage_ccs_portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
	},
	{
		id: "voyage_ccs_portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		id: "voyage_ccs_departureTime",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "departureTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "voyage_ccs_arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "arrivalTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "voyage_ccs_carbonCapture",
		header: "Amount of carbon capture & storage (MT)",
		accessorKey: "carbonCapture",
	},
	{
		id: "voyage_ccs_co2EqMrv",
		header: "CO2eq MRV(MT)",
		accessorKey: "co2EqMrv",
	},
	{
		id: "voyage_ccs_co2EqEts",
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	},
];

export const EuVoyagesDerogationOMRColumns = [
	{
		id: "voyage_omr_VoyageNumber",
		header: "Voyage Number",
		accessorKey: "VoyageNumber",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "voyage_omr_portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
	},
	{
		id: "voyage_omr_portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		id: "voyage_omr_departureTime",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "departureTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "voyage_omr_arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "arrivalTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "voyage_omr_isSi",
		header: "Is Small Island Applicable?",
		accessorKey: "isSi",
		Cell: ({ row }) => {
			const isSi = row?.original?.isSi;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isSi}
						checked={isSi}
					/>
				</div>
			);
		},
	},
	{
		id: "voyage_omr_isTnl",
		header: "Is Transnational Applicable?",
		accessorKey: "isTnl",
		Cell: ({ row }) => {
			const isTnl = row?.original?.isTnl;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isTnl}
						checked={isTnl}
					/>
				</div>
			);
		},
	},
	{
		id: "voyage_omr_isOmr",
		header: "Is OMR Applicable?",
		accessorKey: "isOmr",
		Cell: ({ row }) => {
			const isOmr = row?.original?.isOmr;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isOmr}
						checked={isOmr}
					/>
				</div>
			);
		},
	},
	{
		id: "voyage_omr_reductionFactor",
		header: "Reduction factor (RF)",
		accessorKey: "reductionFactor",
	},
	{
		id: "voyage_omr_co2Mrv",
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		id: "voyage_omr_ch4Mrv",
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		id: "voyage_omr_n2oMrv",
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		id: "voyage_omr_co2EqMrv",
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		id: "voyage_omr_co2Ets",
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		id: "voyage_omr_ch4Ets",
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		id: "voyage_omr_n2oEts",
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		id: "voyage_omr_co2EqEts",
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	},
];

export const EuVoyagesDerogationIceClassColumns = [
	{
		id: "voyage_Ice_VoyageNumber",
		header: "Voyage Number",
		accessorKey: "VoyageNumber",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "voyage_Ice_portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
	},
	{
		id: "voyage_Ice_portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		id: "voyage_Ice_departureTime",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "departureTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "voyage_Ice_arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "arrivalTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "voyage_Ice_iceClass",
		header: "Ice Class",
		accessorKey: "iceClass",
	},
	{
		id: "voyage_Ice_reductionFactor",
		header: "Reduction factor (RF)",
		accessorKey: "reductionFactor",
	},
	{
		id: "voyage_Ice_co2Mrv",
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		id: "voyage_Ice_ch4Mrv",
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		id: "voyage_Ice_n2oMrv",
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		id: "voyage_Ice_co2EqMrv",
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		id: "voyage_Ice_co2Ets",
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		id: "voyage_Ice_ch4Ets",
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		id: "voyage_Ice_n2oEts",
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		id: "voyage_Ice_co2EqEts",
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	},
];

export const EuVoyagesDerogationPhaseInColumns = [
	{
		id: "voyage_phase_vNo",
		header: "Voyage Number",
		accessorKey: "",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "voyage_phase_portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
	},
	{
		id: "voyage_phase_portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		id: "voyage_phase_departureTime",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "departureTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "voyage_phase_arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "arrivalTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "voyage_phase_reportingYear",
		header: "Reporting Year",
		accessorKey: "reportingYear",
	},
	{
		id: "voyage_phase_reductionFactor",
		header: "Reduction factor (RF)",
		accessorKey: "reductionFactor",
	},
	{
		id: "voyage_phase_co2Mrv",
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		id: "voyage_phase_ch4Mrv",
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		id: "voyage_phase_n2oMrv",
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		id: "voyage_phase_co2EqMrv",
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		id: "voyage_phase_co2Ets",
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		id: "voyage_phase_ch4Ets",
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		id: "voyage_phase_n2oEts",
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		id: "voyage_phase_co2EqEts",
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	},
];

export const EuVoyagesEmissionsAfterDerogationColumns = [
	{
		header: "Voyage Number",
		accessorKey: "VoyageNumber",
		id: "VoyageEm_VoyageNumber",
		Cell: ({ row }) => row.index + 1,
	},
	{
		header: "Is Sample Voyage",
		id: "VoyageEm_isSampleVoyage",
		accessorKey: "isSampleVoyage",
		Cell: ({ row }) => {
			const isSampleVoyage = row?.original?.isSampleVoyage;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isSampleVoyage}
						checked={isSampleVoyage}
					/>
				</div>
			);
		},
	},
	{
		id: "VoyageEm_portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
	},
	{
		id: "VoyageEm_portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		id: "VoyageEm_departureTime",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "departureTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "VoyageEm_arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "arrivalTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "VoyageEm_voyageDuration",
		header: "Voyage Duration (h)",
		accessorKey: "voyageDuration",
	},
	{
		id: "VoyageEm_timeAtSea",
		header: "Time at Sea (h)",
		accessorKey: "timeAtSea",
	},
	{
		id: "VoyageEm_calcTimeAtSea",
		header: "Calc Time at Sea (h)",
		accessorKey: "calcTimeAtSea",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "VoyageEm_timeAtAnchor",
		header: "Time at Anchorage (h)",
		accessorKey: "timeAtAnchor",
	},
	{
		id: "VoyageEm_distanceTravelled",
		header: "Distance Travelled (nm)",
		accessorKey: "distanceTravelled",
	},
	{
		id: "VoyageEm_calcDistanceTravelled",
		header: "Calculated Distance (nm)",
		accessorKey: "calcDistanceTravelled",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "VoyageEm_sailingInIce",
		header: "Sailing in Ice (Y/N)",
		accessorKey: "sailingInIce",
		Cell: ({ row }) => {
			const sailingInIce = row?.original?.sailingInIce;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!sailingInIce}
						checked={sailingInIce}
					/>
				</div>
			);
		},
	},
	{
		id: "Time_at_sea_through_ice",
		header: "Time at Sea Ice (h)",
		accessorKey: "timeAtSeaThroughIce",
	},
	{
		id: "Distance_travelled_through_ice",
		header: "Distance Travel Ice(nm)",
		accessorKey: "distanceTravelledThroughIce",
	},

	{
		id: "VoyageEm_cargoMt",
		header: "Cargo Carried (MT)",
		accessorKey: "cargoMt",
	},
	{
		id: "VoyageEm_cargoM3",
		header: "Cargo Carried (M3)",
		accessorKey: "cargoM3",
	},
	{
		id: "VoyageEm_cargoDwt",
		header: "Cargo Carried (DWT)",
		accessorKey: "cargoDwt",
	},
	{
		id: "VoyageEm_cargoPax",
		header: "Cargo Carried (PAX)",
		accessorKey: "cargoPax",
	},
	{
		id: "VoyageEm_amountOfCarbonCapture",
		header: "Amount of carbon capture & storage (MT)",
		accessorKey: "amountOfCarbonCapture",
	},
	{
		id: "VoyageEm_co2Mrv",
		header: "CO2 MRV (MT)",
		accessorKey: "co2Mrv",
	},
	{
		id: "VoyageEm_ch4Mrv",
		header: "CH4 MRV (MT)",
		accessorKey: "ch4Mrv",
	},
	{
		id: "VoyageEm_n2oMrv",
		header: "N2O MRV (MT)",
		accessorKey: "n2oMrv",
	},
	{
		id: "VoyageEm_co2EqMrv",
		header: "CO2eq MRV (MT)",
		accessorKey: "co2EqMrv",
	},
	{
		id: "VoyageEm_co2Ets",
		header: "CO2 ETS (MT)",
		accessorKey: "co2Ets",
	},
	{
		id: "VoyageEm_ch4Ets",
		header: "CH4 ETS (MT)",
		accessorKey: "ch4Ets",
	},
	{
		id: "VoyageEm_n2oEts",
		header: "N2O ETS (MT)",
		accessorKey: "n2oEts",
	},
	{
		id: "VoyageEm_co2EqEts",
		header: "CO2eq ETS (MT)",
		accessorKey: "co2EqEts",
	},
	{
		id: "VoyageEm_description",
		header: "Description",
		accessorKey: "description",
	},
];

export const UKMRVVoyageColumnsData = [
	{
		id: "voyageNumber",
		header: "Voyage Number",
		accessorKey: "",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "isSampleVoyage",
		header: "Is Sample Voyage",
		accessorKey: "isSampleVoyage",
		Cell: ({ row }) => {
			const isSampleVoyage = row?.original?.isSampleVoyage;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isSampleVoyage}
						checked={isSampleVoyage}
					/>
				</div>
			);
		},
	},
	{
		id: "portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
	},
	{
		id: "portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		id: "departureTime",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "departureTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
	},
	{
		id: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "arrivalTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "voyageDuration",
		header: "Voyage Duration (h)",
		accessorKey: "voyageDuration",
	},
	{
		id: "timeAtSea",
		header: "Time at Sea (h)",
		accessorKey: "timeAtSea",
	},
	{
		id: "calcTimeAtSea",
		header: "Calc Time at Sea (h)",
		accessorKey: "calcTimeAtSea",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "timeAtAnchor",
		header: "Time at Anchorage (h)",
		accessorKey: "timeAtAnchor",
	},
	{
		id: "distanceTravelled",
		header: "Distance Travelled (nm)",
		accessorKey: "distanceTravelled",
	},
	{
		id: "calcDistanceTravelled",
		header: "Calc Distance (nm)",
		accessorKey: "calcDistanceTravelled",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "cargoMt",
		header: "Cargo Carried (MT)",
		accessorKey: "cargoMt",
	},
	{
		id: "cargoM3",
		header: "Cargo Carried (M3)",
		accessorKey: "cargoM3",
	},
	{
		id: "cargoDwt",
		header: "Cargo Carried (DWT)",
		accessorKey: "cargoDwt",
	},
	{
		id: "cargoPax",
		header: "Cargo Carried (PAX)",
		accessorKey: "cargoPax",
	},
	{
		id: "description",
		header: "Description",
		accessorKey: "description",
	},
];

export const UKMRVOldVoyageColumnsData = [
	{
		id: "VoyageNumber",
		header: "Voyage Number",
		accessorKey: "",
		Cell: ({ row }) => row.index + 1,
	},
	{
		id: "isSampleVoyage",
		header: "Is Sample Voyage",
		accessorKey: "isSampleVoyage",
		Cell: ({ row }) => {
			const isSampleVoyage = row?.original?.isSampleVoyage;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox
						className="p-0"
						size="small"
						disabled={!isSampleVoyage}
						checked={isSampleVoyage}
					/>
				</div>
			);
		},
	},
	{
		id: "portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
	},
	{
		id: "portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
	},
	{
		id: "dateTimeDeparture",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "dateTimeDeparture",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateTimeDeparture) {
				return convertLocaltoUTCFormat(row.dateTimeDeparture);
			}
		},
	},
	{
		id: "dateTimeArrival",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "dateTimeArrival",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.dateTimeArrival) {
				return convertLocaltoUTCFormat(row.dateTimeArrival);
			}
		},
	},
	{
		id: "voyageDuration",
		header: "Voyage Duration (h)",
		accessorKey: "voyageDuration",
	},
	{
		id: "timeAtSea",
		header: "Time at Sea (h)",
		accessorKey: "timeAtSea",
	},
	{
		id: "calcTimeAtSea",
		header: "Calc Time at Sea (h)",
		accessorKey: "calcTimeAtSea",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "timeAtAnchor",
		header: "Time at Anchorage (h)",
		accessorKey: "timeAtAnchor",
	},
	{
		id: "distanceTravelled",
		header: "Distance Travelled (nm)",
		accessorKey: "distanceTravelled",
	},
	{
		id: "calcDistance",
		header: "Calc Distance (nm)",
		accessorKey: "calcDistance",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "cargoCarriedMt",
		header: "Cargo Carried (MT)",
		accessorKey: "cargoCarriedMt",
	},
	{
		id: "cargoCarriedM3",
		header: "Cargo Carried (M3)",
		accessorKey: "cargoCarriedM3",
	},
	{
		id: "cargoCarriedDwt",
		header: "Cargo Carried (DWT)",
		accessorKey: "cargoCarriedDwt",
	},
	{
		id: "cargoCarriedPax",
		header: "Cargo Carried (PAX)",
		accessorKey: "cargoCarriedPax",
	},
	{
		id: "hfoCons",
		header: "HFO Cons. (MT)",
		accessorKey: "hfoCons",
	},
	{
		id: "lfoCons",
		header: "LFO Cons. (MT)",
		accessorKey: "lfoCons",
	},
	{
		id: "mdoCons",
		header: "MDO Cons",
		accessorKey: "mdoCons",
	},
	{
		id: "mgoCons",
		header: "MGO Cons",
		accessorKey: "mgoCons",
	},
	{
		id: "lpgpCons",
		header: "LPG (Propane) Cons. (MT)",
		accessorKey: "lpgpCons",
	},
	{
		id: "lpgbCons",
		header: "LPG (Butane) Cons. (MT)",
		accessorKey: "lpgbCons",
	},
	{
		id: "lngCons",
		header: "LNG Cons. (MT)",
		accessorKey: "lngCons",
	},
	{
		id: "lngMnc",
		header: "LNG MNC. (MT)",
		accessorKey: "lngMnc",
	},
	{
		id: "methanolCons",
		header: "Methanol Cons. (MT)",
		accessorKey: "methanolCons",
	},
	{
		id: "ethanolCons",
		header: "Ethanol Cons. (MT)",
		accessorKey: "ethanolCons",
	},
	{
		id: "otherFuel1Cons",
		header: "Other Fuel 1 Cons. (MT)",
		accessorKey: "otherFuel1Cons",
	},
	{
		id: "otherFuel1Mnc",
		header: "Other Fuel 1 MNC. (MT)",
		accessorKey: "otherFuel1Mnc",
	},
	{
		id: "otherFuel2Cons",
		header: "Other Fuel 2 Cons. (MT)",
		accessorKey: "otherFuel2Cons",
	},
	{
		id: "otherFuel2Mnc",
		header: "Other Fuel 2 MNC. (MT)",
		accessorKey: "otherFuel2Mnc",
	},
	{
		id: "otherFuel3Cons",
		header: "Other Fuel 3 Cons. (MT)",
		accessorKey: "otherFuel3Cons",
	},
	{
		id: "otherFuel3Mnc",
		header: "Other Fuel 3 MNC. (MT)",
		accessorKey: "otherFuel3Mnc",
	},
	{
		id: "directCo2",
		header: "Direct CO2 Measurement (MT)",
		accessorKey: "directCo2",
	},
	{
		id: "description",
		header: "Description",
		accessorKey: "description",
	},
];
export const ETS_COLUMN_KEYS = ["co2Ets", "ch4Ets", "n2oEts", "co2EqEts"];
export const MRV_COLUMN_KEYS = ["co2Mrv", "ch4Mrv", "n2oMrv", "co2EqMrv"];

export const UKETSVoyageColumnsData = [
	{
		id: "voyageNumber",
		header: "Voyage Number",
		accessorKey: "",
		Cell: ({ row }) => row.index + 1,
		size: 100,

	},
	{
		id: "isSampleVoyage",
		header: "Is Sample Voyage",
		accessorKey: "isSampleVoyage",
		Cell: ({ row }) => {
			const isSampleVoyage = row?.original?.isSampleVoyage;
			return (
				<div className="d-flex justify-content-start">
					<Checkbox className="p-0" size="small" disabled={!isSampleVoyage} checked={isSampleVoyage} />
				</div>
			);
		},
		size: 90,

	},
	{
		id: "portOfDeparture",
		header: "Port of Departure",
		accessorKey: "portOfDeparture",
		size: 150,
	},
	{
		id: "portOfArrival",
		header: "Port of Arrival",
		accessorKey: "portOfArrival",
		size: 150,
	},
	{
		id: "departureTime",
		header: "Date and Time of Departure (UTC)",
		accessorKey: "departureTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.departureTime) {
				return convertLocaltoUTCFormat(row.departureTime);
			}
		},
		size: 170,
	},
	{
		id: "arrivalTime",
		header: "Date and Time of Arrival (UTC)",
		accessorKey: "arrivalTime",
		muiEditTextFieldProps: {
			type: "datetime-local",
		},
		accessorFn: (row) => {
			if (row.arrivalTime) {
				return convertLocaltoUTCFormat(row.arrivalTime);
			}
		},
	},
	{
		id: "betweenGBandNI",
		header: "Between GB and NI(Y/N)",
		accessorKey: "betweenGBandNI",
	},
	{
		id: "voyageDuration",
		header: "Voyage Duration (h)",
		accessorKey: "voyageDuration",
	},
	{
		id: "timeAtSea",
		header: "Time at Sea (h)",
		accessorKey: "timeAtSea",
	},
	{
		id: "calcTimeAtSea",
		header: "Calc. Time at Sea(h)",
		accessorKey: "calcTimeAtSea",
	},
	{
		id: "timeAtAnchor",
		header: "Time at Anchorage (h)",
		accessorKey: "timeAtAnchor",
	},
	{
		id: "distanceTravelled",
		header: "Distance Travelled (nm)",
		accessorKey: "distanceTravelled",
	},
	{
		id: "calcDistanceTravelled",
		header: "Calc Distance (nm)",
		accessorKey: "calcDistanceTravelled",
		condition: ClaimType.VIEW_ABS_INTERNAL_COLUMNS,
	},
	{
		id: "sailingInIce",
		header: "Sailing in Ice (Y/N)",
		accessorKey: "sailingInIce",
	},
		{
		id: "cargoMt",
		header: "Cargo Carried (MT)",
		accessorKey: "cargoMt",
	},
	
];

export const UKETSVoyagesEtsColumnsData = [

	{
		id: "co2Ets",
		header: "CO2 ETS",
		accessorKey: "co2Ets",
		size: 90,
	},
	{
		id: "ch4Ets",
		header: "CH4 ETS",
		accessorKey: "ch4Ets",
		size: 90,
	},
	{
		id: "n2oEts",
		header: "N2O ETS",
		accessorKey: "n2oEts",
		size: 90,
	},
	{
		id: "meEts",
		header: "ME ETS",
		accessorKey: "meEts",
		size: 90,
	},
];
export const UKETSEtsPortstaysColumnsData = [
	{
		id: "co2Ets",
		header: "CO2 ETS",
		accessorKey: "co2Ets",
	},
	{
		id: "ch4Ets",
		header: "CH4 ETS",
		accessorKey: "ch4Ets",
	},
	{
		id: "n2oEts",
		header: "N2O ETS",
		accessorKey: "n2oEts",
	},
	{
		id: "meEts",
		header: "ME ETS",
		accessorKey: "meEts",
	},
];
